export const modalNewSubmissionBodyStyle = (showModalForm: boolean) => ({
  //TODO: change to module css when Modal component is updated
  ".MuiDialogContent-root": {
    pb: 0,
    pt: `${showModalForm ? "24px " : "16px "} !important`,
    px: showModalForm ? 3 : 2,
  },
});
